module.exports = __webpack_public_path__ + "Roboto-Thin.790ebf41d0214f5eda4e.woff2";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Thin.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Thin.woff2
// module chunks = 5